export default __webpack_public_path__ + "static/media/desk-bed.5767c1df.jpg";